<template>
  <modal name="services-modal"
    :classes="['v--modal', 'services-modal']"
    :pivot-y="0.16"
    :pivot-x="0.92"
    :width="260"
    :height="320"
    >

    <div class="services-modal-content">
      <h6>My Account</h6>
      <v-row>
          <v-col
            cols="12"
            sm="4"
           >
              <router-link to="/mypolicies" style="text-decoration:none">
                <div @click="$modal.hide('services-modal')">
                  <font-awesome-icon color="#052f66" size="2x" icon="clipboard-list" />
                </div>
                <p style="font-size:11px;color:black">My Policies</p>
              </router-link>
          </v-col>
          <v-col
            cols="12"
            sm="4"
           >
            <router-link to="/myclaims" style="text-decoration:none">
              <div @click="$modal.hide('services-modal')">
                <font-awesome-icon color="#052f66" size="2x" icon="file-signature" />
              </div>
              <p style="font-size:11px;color:black">My Claims</p>
            </router-link>
          </v-col>
          <v-col
            cols="12"
            sm="4"
           >
            <router-link to="/promotions" style="text-decoration:none">
              <div @click="$modal.hide('services-modal')">
                <font-awesome-icon color="#052f66" size="2x" icon="medal" />
              </div>
              <p style="font-size:11px;color:black">Promotions</p>
            </router-link>
          </v-col>
      </v-row>
      <v-row>
          <v-col
            cols="12"
            sm="4"
           >
              <div>
                <font-awesome-icon color="#052f66" size="2x" icon="location-arrow" />
              </div>
              <p style="font-size:11px;color:black">Agents</p>
          </v-col>
          <v-col
            cols="12"
            sm="4"
           >
              <div>
                <font-awesome-icon color="#052f66" size="2x" icon="reply" />
              </div>
              <p style="font-size:11px;color:black">File Claim</p>
          </v-col>
          <v-col
            cols="12"
            sm="4"
           >
              <div>
                <font-awesome-icon color="#052f66" size="2x" icon="hands-helping" />
              </div>
              <p style="font-size:11px;color:black">Get Help</p>
          </v-col>
      </v-row>
    </div>
  </modal>
</template>
<script>
export default {
  name: 'ServicesModal',
}
</script>
<style lang="scss">
.services-modal {
  transition: box-shadow 1s;
  position: absolute;
}
.services-modal-content {
  padding: 10px;
  text-align: center;  
  button {
    width: 180px;
  }
  
}
h6{
    font-weight:normal;
}
</style>